// colors
export const EERIE_BLACK = "#090B0E";
export const LIGHT_EERIE_BLACK = "#15191F";
export const LIGHT_WHITE = "#FFFFFF10";
export const GAINSBORO = "#DADDD8";
export const LIGHT_GAINSBORO = "#DADDD840";
export const ALABASTER = "#ECEBE4";
export const CULTURED = "#EEF0F2";
export const GHOST_WHITE = "#FAFAFF";

// breakpoints
export const TABLET_BREAKPOINT = 564;
export const SMALL_MOBILE_BREAKPOINT = 375;
export const DESKTOP_BREAKPOINT = 1024;

// fonts
export const PRIMARY_FONT = "'Inter', sans-serif";
export const SECONDARY_FONT = "'Fira Code', monospace";

// font sizes
export const TITLE_SIZE = "6.4rem";
export const SMALL_TITLE_SIZE = "2.2rem";
export const PRIMARY_SIZE = "1.8rem";
export const SECONDARY_SIZE = "1.6rem";
export const SMALL_SECONDARY_SIZE = "1.4rem";

// font weights
export const SLIM_WEIGHT = "300";
export const NORMAL_WEIGHT = "400";
export const BOLDER_WEIGHT = "700";
export const BOLD_WEIGHT = "bold";

// line heights
export const NORMAL_HEIGHT = "2.6rem";
